import { render, staticRenderFns } from "./ZarinPalCallback.vue?vue&type=template&id=16821b5c&scoped=true"
import script from "./ZarinPalCallback.vue?vue&type=script&lang=js"
export * from "./ZarinPalCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16821b5c",
  null
  
)

export default component.exports